import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ManagementActHub from 'components/contract/managementAct/ManagementActHub';

const ManagementAct = () => (
    <Routes>
        <Route exact path="/managementActHub/:compagnyChoice" element={<ManagementActHub />} />
    </Routes>
);

export default ManagementAct;
